
export default {
    getTab: {
        'result': {
            'error': 0
        },
        'content': {
            'tablist': [
                {
                    'show_name': '赏花',
                    'name': 'flower',
                    'icon': '',
                    'upd_time': 0
                },
                {
                    'show_name': '春游',
                    'name': 'tour',
                    'icon': '',
                    'upd_time': 0
                },
                {
                    'show_name': '推荐',
                    'name': 'default',
                    'icon': '',
                    'upd_time': 0
                }
            ]
        }
    }
};